module.exports = __webpack_public_path__ + "static/media/dark-blue-top-arrow-pointer.eaf01343.svg";